import { Component } from "@angular/core";
import { OpenCategoryCoeDepositoryService } from "src/app/services/autopac/open-category-coe-depository.service";
import { FormField } from "src/app/interfaces/form-field.model";

@Component({
  selector: "app-open-category-coe-depository",
  templateUrl: "./open-category-coe-depository.component.html",
  styleUrls: ["./open-category-coe-depository.component.css"],
})
export class OpenCategoryCoeDepositoryComponent {
  lockBtn: boolean = true;

  form: FormField[] = [
    {
      type: "number",
      id: "COEAMOUNT",
      label: "COE Amount",
      required: true,
    },
    {
      type: "date",
      id: "COEBIDDATE",
      label: "COE Bid Date (dd/mm/yyyy)",
      required: true,
    },
    {
      type: "date",
      id: "EXPIRYDATE",
      label: "COE Expiry Date (dd/mm/yyyy)",
      required: true,
    },
    {
      type: "number",
      id: "NumberOfSuccessBids",
      label: "Number of Success Bids",
      required: true,
    },
  ];

  constructor(private coeService: OpenCategoryCoeDepositoryService) {}

  updateFields(): void {
    this.lockBtn = !this.form.every((item) => item.value);
  }

  clearForm(): void {
    this.form.forEach((field) => {
      field.value = undefined;
    });
    this.lockBtn = true;
  }

  addEntry(): void {
    const payload = this.mapFormToPayload();
    this.coeService.add(payload).subscribe((response) => {
      console.log("API Response:", response);
      const message =
        response?.body?.Message ||
        response?.message ||
        "Unexpected API response.";
      alert(message);
      this.clearForm();
    });
  }

  moveOrRetrieve(): void {
    const payload = this.mapFormToPayload();
    this.coeService.moveOrRetrieve(payload).subscribe((response) => {
      console.log("API Response:", response);
      const message =
        response?.body?.Message ||
        response?.message ||
        "Unexpected API response.";
      alert(message);
      this.clearForm();
    });
  }

  private mapFormToPayload(): any {
    return this.form.reduce((acc: Record<string, any>, field) => {
      if (field.type === "date" && field.value) {
        const date = new Date(field.value);
        acc[field.id] = date.toLocaleDateString("en-GB");
      } else if (field.type === "number") {
        acc[field.id] = Number(field.value);
      } else {
        acc[field.id] = field.value;
      }
      return acc;
    }, {});
  }
}
